export default __webpack_public_path__ + "static/media/assembled-universe-logo.7e036408.svg";